import React from 'react';
import { Link } from 'react-router-dom';

const PaymentFailed = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-red-50 text-center px-4">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full">
        {/* Failed Icon */}
        <div className="flex justify-center items-center bg-red-100 rounded-full w-20 h-20 mx-auto mb-6">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-4xl font-bold text-red-600 mb-4">Payment Failed</h1>

        {/* Description */}
        <p className="text-gray-700 mb-6 text-lg">
          Oops! Something went wrong, and your payment could not be completed.
          This may be due to a network issue or an error with your payment
          method.
        </p>
             
      </div>
    </div>
  );
};

export default PaymentFailed;
